import React from "react";
import { Row, Col } from "react-bootstrap";
import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
import dayjs from "dayjs";
import EzControlledInput from "../../../../common/EzForm/EzControlledInput";
import { getFormBaseValidationRule } from "../../../../utils/form/form-utils";
import EzControlledDropDowntWithFloatingLabel from "../../../../common/EzForm/EzControlledDropDown/WithFloatingLabel";
import EzControlledCalendarWithFloatingLabel from "../../../../common/EzForm/EzControlledCalendar/WithFloatingLabel";
const PAYMENT_MODE_OPTION = [
  { label: "Cheque", value: "Cheque" },
  { label: "Cash", value: "Cash" },
  { label: "Interac/debit/credit", value: "interac_debit_credit" },
];
const CreateInvoicePayment = (props) => {
  const {
    closeDialog,
    selectedInvoiceRecord,
    invoicePaymentModeDD,
    createInvoicePayment,
  } = props;

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors, isDirty },
  } = useForm({
    defaultValues: {
      payment_date: "",
      company_name: selectedInvoiceRecord?.company_name || "",
      invoice_number: selectedInvoiceRecord?.invoice_number || "",
      amount_due: selectedInvoiceRecord?.amount_due || 0,
      amount_paid: "",
      currency: selectedInvoiceRecord?.currency || "",
      payment_mode: "",
      referenceId: "",
    },
  });

  const getFormErrorMessage = (name) => {
    if (errors[name]) {
      const errorMessage = errors[name]?.message || "This field is required.";
      return <small className="p-error">{errorMessage}</small>;
    }
    return null;
  };

  const onSubmit = (data) => {
    if (!isDirty) return;
    const { invoice_number: invoice_id, amount_paid, ...rest } = data;
    const payload = {
      ...rest,
      invoice_id,
      amount_paid: Number(amount_paid),
      payment_date: dayjs(data.payment_date).format("YYYY-MM-DD"),
    };
    console.log("invoice-payment-payload", payload);
    createInvoicePayment({ payload });
    closeDialog();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Row>
        <Col md={12}>
          <EzControlledCalendarWithFloatingLabel
            name="payment_date"
            rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
            control={control}
            isError={!!errors.payment_date}
            errorMsg={getFormErrorMessage("payment_date")}
            label={"Payment Date"}
            inputClassName="w-100"
          />
        </Col>
      </Row>
      <Row className="rowposition">
        <Col md={12}>
          <EzControlledInput
            name="company_name"
            control={control}
            label="Customer"
            rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
            errorMsg={getFormErrorMessage("company_name")}
            isError={!!errors.company_name}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <EzControlledInput
            name="invoice_number"
            control={control}
            label="Invoice"
            rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
            errorMsg={getFormErrorMessage("invoice_number")}
            isError={!!errors.invoice_number}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <EzControlledInput
            name="amount_due"
            control={control}
            label="Amount Due"
            rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
            errorMsg={getFormErrorMessage("amount_due")}
            isError={!!errors.amount_due}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <EzControlledInput
            name="amount_paid"
            control={control}
            label="Amount Paid"
            rules={{
              ...getFormBaseValidationRule().DEFAULT.VALIDATION_RULE,
              validate: (value) => {
                const amountDue = Number(control._formValues.amount_due);
                return (
                  Number(value) <= amountDue ||
                  "Amount paid cannot exceed amount due."
                );
              },
            }}
            errorMsg={getFormErrorMessage("amount_paid")}
            isError={!!errors.amount_paid}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <EzControlledInput
            name="currency"
            control={control}
            label="Currency"
            rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
            errorMsg={getFormErrorMessage("currency")}
            isError={!!errors.currency}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <EzControlledDropDowntWithFloatingLabel
            name="payment_mode"
            control={control}
            label="Payment Mode"
            options={PAYMENT_MODE_OPTION}
            optionLabel="label"
            optionValue="value"
            rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
            errorMsg={getFormErrorMessage("payment_mode")}
            isError={!!errors.payment_mode}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <EzControlledInput
            name="referenceId"
            control={control}
            label="Reference Id"
            rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
            errorMsg={getFormErrorMessage("referenceId")}
            isError={!!errors.referenceId}
          />
        </Col>
      </Row>
      <div className="d-flex justify-content-end">
        <Button
          type="button"
          label="Cancel"
          className="p-btn-danger p-button-outlined"
          onClick={closeDialog}
        />
        <Button type="submit" label="Save" className="p-button-raised ml-2" />
      </div>
    </form>
  );
};

export default CreateInvoicePayment;
